import Layout from "@/app/common-modules/layout/Layout";
/**
 *@author       罗朝军
 *@date         2021/9/11 11:55
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */

const shoppingRouter = [
  {
    path: "",
    component: Layout,
    redirect: "",
    children: [
      {
        path: "",
        component: () => import("@/app/shop/views/shopping.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "shopping"
      },
      {
        path: "/retrievePassword",
        component: () => import("@/app/shop/views/retrievePassword.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "retrievePassword"
      },
      {
        path: "/viewNoticeDetail",
        component: () => import("@/app/shop/views/viewNoticeDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewNoticeDetail"
      },
      {
        path: "/operationManual",
        component: () => import("@/app/shop/views/operationManual.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "operationManual"
      },
      {
        path: "/question",
        component: () => import("@/app/shop/views/question.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "question"
      },
      {
        path: "/announcementsList",
        component: () => import("@/app/shop/views/announcementsList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementsList"
      },
      {
        path: "/announcementDetail",
        component: () => import("@/app/shop/views/announcementDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementDetail"
      },
      {
        path: "/searchList",
        component: () => import("@/app/shop/views/searchList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "searchList"
      },
      {
        path: "/viewNoticeSimpleDetail",
        component: () => import("@/app/shop/views/viewNoticeSimpleDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewNoticeSimpleDetail"
      },
      {
        path: "/operationHandbook",
        component: () => import("@/app/shop/views/operationHandbook.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "operationHandbook"
      },
      {
        path: "/infoManageNetworkAccess",
        component: () => import("@/app/shop/views/infoManageNetworkAccess.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "infoManageNetworkAccess"
      },
      {
        path: "/infoManageQuestionDeil",
        component: () => import("@/app/shop/views/infoManageQuestionDeil.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "infoManageQuestionDeil"
      }
    ]
  }
];

export default shoppingRouter;
